import React, { Component } from 'react';
import autobind from 'class-autobind';
import forEach from 'lodash/forEach';
import omit from 'lodash/omit';
import map from 'lodash/map';
import filter from 'lodash/filter';
import noop from 'lodash/noop';
import includes from 'lodash/includes';

import BaseModal from 'zoomforth_component_lib/base_modal.jsx';
import ReplaceAssetModalUI from './replace_asset_modal_ui.jsx';
import selectFilesWithOs from 'zoomforth_zfutils/select_files_with_os.js';
import { uploadFileAndFetchAsset } from 'zoomforth_codesbane_editor/lib/assets.js';
import { getZfImageForAsset } from 'zoomforth_media_library/lib/assets.js';
import { makeRandomAlphaNumeric } from 'zoomforth_zfutils/random.js';
import MediaLibraryAsset from 'zoomforth_media_library/models/media_library_asset.js';
import { PROCESSABLE_ASSET_EXTENSIONS } from 'const_shared.js';

const initialState = {
  currentView: 'site-list',
  selected: {},
  isReplacing: false,
  isReplaceSuccess: false,
  was_original_asset_deleted: false
};

class ReplaceAssetModal extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = { ...initialState };
  }

  resetState(callback) {
    this.setState({ ...initialState, selected: this.state.selected }, callback);
  }

  handleToggleSelectAll() {
    if (Object.keys(this.state.selected).length == this.props.siteList.length) {
      this.setState({ selected: {} });
      return;
    }

    const selected = {};
    forEach(this.props.siteList, (site) => {
      selected[site.id] = true;
    });

    this.setState({ selected: selected });
  }

  handleToggleSelectSite(siteId) {
    if (this.state.selected[siteId]) {
      this.setState({ selected: omit(this.state.selected, [siteId]) });
    } else {
      this.setState({ selected: { ...this.state.selected, [siteId]: true } });
    }
  }

  handleReplace() {
    const assetType = this.props.assetModel.get('assetType');

    const accept = {
      'html_package': ['.zip'],
      'pdf': map(PROCESSABLE_ASSET_EXTENSIONS['pdf_extensions'], (extension) => `.${extension}` ),
      'ppt': map(PROCESSABLE_ASSET_EXTENSIONS['pdf_extensions'], (extension) => `.${extension}` ),
      'video': map(PROCESSABLE_ASSET_EXTENSIONS['video_extensions'], (extension) => `.${extension}` ),
      'photo': map(PROCESSABLE_ASSET_EXTENSIONS['image_extensions'], (extension) => `.${extension}` )
    }[assetType];

    selectFilesWithOs({ multiple: false, accept }).done(files => {
      const file = files[0];

      var forceAssetType = null;
      if(includes(['html_package', 'ppt'], assetType)){
        forceAssetType = this.props.assetModel.get('assetType');
      }

      this.setState({ currentView: 'replace', isReplacing: true }, () => {
        uploadFileAndFetchAsset(file, {
          uploadContext: 'zoomforth_user_upload',
          forceAssetType,
          onProgressChange: noop,
          onAssetReceive: (asset) => {
            const { id, assetType } = asset;

            if (assetType != this.props.assetModel.get('assetType')) {
              this.resetState(() => this.props.onShowReplaceErrorNotification(`You have to replace an asset with another asset of the same type. Please choose a ${this.props.assetModel.get('assetType')} file instead and try again.`));
              return;
            }

            const newAssetModel = new MediaLibraryAsset({ id: `${assetType}-${id}` });
            newAssetModel.fetch();
            newAssetModel.save(
              { parent_folder_id: this.props.currentFolder.id },
              { patch: true }
            ).done(() => {

              const site_ids = map(Object.keys(this.state.selected), (id) => parseInt(id));
              const params = {
                original_asset_ident: this.props.assetModel.id,
                new_asset_ident: newAssetModel.id,
                is_partial_replace: site_ids.length != this.props.siteList.length,
                site_ids
              };

              if (newAssetModel.get('assetType') == 'photo') {
                params.zf_image = getZfImageForAsset(newAssetModel);
              }

              this.props.onAssetReplace(
                params,
                {
                  onSuccess: (response) => {
                    this.setState({ isReplacing: false, isReplaceSuccess: true, was_original_asset_deleted: response.was_original_asset_deleted });
                  },
                  onError: () => this.resetState(() => this.props.onShowReplaceErrorNotification())
                });
            });
          },
          onError: () => {
            this.resetState(() => this.props.onShowReplaceErrorNotification());
          }
        });
      });
    });
  }

  render() {
    const onClose = () => {
      if (this.state.was_original_asset_deleted) {
        this.props.onClearAssetSelection();
      }
      this.props.onClose();
    };

    const selectedSites = filter(this.props.siteList, (site) => this.state.selected[site.id]);
    const hasSelectedAll = Object.keys(this.state.selected).length >= this.props.siteList.length;

    return (
      <BaseModal
        style={{ padding: '0', width: '464px', height: '580px' }}
        onRequestClose={onClose}
      >
        <div id={`replace-asset-modal-${makeRandomAlphaNumeric(5)}`}>
          <ReplaceAssetModalUI
            {...{ ...this.props, ...this.state, hasSelectedAll, selectedSites, onClose }}
            onToggleSelectAll={this.handleToggleSelectAll}
            onToggleSelectSite={this.handleToggleSelectSite}
            onReplace={this.handleReplace}
          />
        </div>
      </BaseModal>
    );
  }
}

export default ReplaceAssetModal;